module.exports = __webpack_public_path__ + "img/dsci0092.690cd1f9.jpg";